<template>
  <form @submit.prevent>
    <FormInput
      v-model="search"
      :placeholder="translations.vendor_location_placeholder"
      name="vendor_location"
      type="text"
    >
      <button
        :style="{ pointerEvents: pointerEventPositionButton }"
        @click="findGeolocation"
        :disabled="!enabledPositionButton"
        v-if="!search"
        class="btn btn-secondary-subtle"
        type="button"
      >
        <span v-if="enabledPositionButton">
          <LocationIcon class="svg-16 svg-fill-current" />
        </span>
        <span v-if="!enabledPositionButton">
          <i class="spinner-border spinner-border-sm"></i>
        </span>
      </button>
      <button
        :style="{ pointerEvents: pointerEventPositionButton }"
        v-if="search"
        @click="clearSearch"
        class="btn btn-secondary-subtle"
        type="button"
      >
        <ClearIcon class="svg-16 svg-fill-current" />
      </button>
    </FormInput>
    <Slider
      v-if="search"
      v-on:maxValueChanged="distanceChanged"
      :options="sliderOptions()"
      class="mt-2"
    ></Slider>
    <button
      v-if="isFilterApplicable"
      @click="submitParameter"
      class="btn btn-primary btn-sm w-100"
      type="submit"
      name="use_filter"
    >
      {{ translations.use_filter }}
    </button>
    <button
      v-if="initialSearch"
      @click="removeParameter"
      :class="{ 'mt-1': isFilterApplicable }"
      class="btn btn-secondary-subtle btn-sm w-100"
      name="remove_filter"
    >
      <i class="fa fa-trash" />
      {{ translations.remove_filter }}
    </button>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";
import ClearIcon from "../../icons/atalanda/close.svg";
import LocationIcon from "../../icons/atalanda/location.svg";
import FormInput from "./FormInput";
import Slider from "./RangeSlider";

export default {
  name: "VendorLocation",
  components: {
    ClearIcon,
    LocationIcon,
    FormInput,
    Slider,
  },
  props: {
    initialSearch: {
      type: String,
      default: "",
    },
    initialDistance: {
      type: String,
      default: "25 km",
    },
    translations: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      enabledPositionButton: true,
      pointerEventPositionButton: "initial",
      search: this.initialSearch,
      distance: this.initialDistance,
    };
  },
  computed: {
    isFilterApplicable() {
      return (
        this.search &&
        this.distance &&
        (this.search !== this.initialSearch || this.distance !== this.initialDistance)
      );
    },
  },
  methods: {
    ...mapActions({
      flash: "flashMessages/flash",
    }),
    async reverseGeocode(position) {
      await axios
        .post("/reverse_geocode", {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          format: "json",
        })
        .then(this.receiveAddress)
        .catch(this.receiveServerError);
    },
    removeParameter() {
      let params = new URLSearchParams(window.location.search);
      params.delete("vendor_location");
      params.delete("vendor_location_distance");
      window.location.assign(
        `${location.pathname}${params.toString() ? "?" + params.toString() : ""}`
      );
    },
    submitParameter() {
      let params = new URLSearchParams(window.location.search);
      params.set("vendor_location", this.search);
      params.set("vendor_location_distance", this.distance);
      window.location.assign(`${location.pathname}?${params.toString()}`);
    },
    async findGeolocation() {
      if ("geolocation" in window.navigator) {
        this.disablePositionButton();
        await window.navigator.geolocation.getCurrentPosition(
          position => {
            this.reverseGeocode(position);
          },
          error => {
            this.receivePositionError();
          }
        );
      } else {
        this.receiveNotSupportedError();
      }
    },
    receiveAddress(response) {
      this.enablePositionButton();
      this.search = response.data.address;
    },
    receiveServerError(error) {
      this.enablePositionButton();
      this.flash({ type: "error", message: error.response.data.error });
    },
    receiveNotSupportedError() {
      this.flash({
        type: "error",
        message: this.translations.vendor_location_geolocation_not_supported,
      });
    },
    receivePositionError() {
      this.enablePositionButton();
      this.flash({
        type: "error",
        message: this.translations.vendor_location_position_error,
      });
    },
    clearSearch() {
      this.search = null;
    },
    disablePositionButton() {
      this.enabledPositionButton = false;
      this.pointerEventPositionButton = "none";
    },
    enablePositionButton() {
      this.enabledPositionButton = true;
      this.pointerEventPositionButton = "initial";
    },
    distanceChanged(distance) {
      this.distance = distance;
    },
    sliderOptions() {
      return {
        behaviour: "drag-tap",
        connect: [true, false],
        start: [this.initialDistance],
        range: {
          min: [5, 5],
          "75%": [25, 25],
          max: [100],
        },
        decimals: 0,
        tooltips: true,
        minInputName: "vendor_location_distance",
        suffix: "km",
        minLabelWidth: "75px",
      };
    },
  },
};
</script>
